import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import RenumberCitationsEditing from './renumbercitationsediting';

export default class RenumberCitations extends Plugin {
  static get pluginName() {
    return 'RenumberCitations';
  }

  static get requires() {
    return [ RenumberCitationsEditing ];
  }
}
